import React from "react";
import { Grid, Paper, Box, Typography, Button } from "@mui/material";
import ButtonComponent from "../ButtonComponent/Button";
import apiService from "../../service";
import StackPackImage from "../../assets/StackPack.png";
import { CheckBox } from "@mui/icons-material";

const SubscriptionCard = ({ plan, selectedCurrency }) => {
  const handleCheckoutSession = async () => {
    const userId = localStorage.getItem("userId");
    const tenantId = localStorage.getItem("tenantId");

    if (selectedCurrency === "USD") {
      const obj = {
        userId: userId,
        tenant_id: tenantId,
        stripe_product_id: plan.stripe_product_id,
        stripe_product_price_id: plan.stripe_product_price_id,
        productName: plan.name,
        quantity: 1,
        currency: "usd",
        unit_amount: plan.totalCost,
        total_amount: plan.totalCost,
        credit_points: plan.totalCredit,
      };
      const createCheckoutSessionResponse =
        await apiService.createCheckoutSession(obj);
      if (createCheckoutSessionResponse) {
        window.location.href = createCheckoutSessionResponse.sessionUrl;
        localStorage.setItem("URL", createCheckoutSessionResponse.sessionUrl);
      }
    }

    // if()
  };
  return (
    <Grid item xs={12} sm={12} md={12 / 2} lg={12 / 5} onClick={() => handleCheckoutSession(plan)} className="subscription-card">
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 300,
          textAlign: "start",
          border: "2px solid #949395",
          backgroundColor: "transparent",
          borderRadius: 3,
          height: "500px",
          position: "relative",
          color: "black",
        }}
      >
        {plan.name === "Starter Pack" ? (
          <>
            <Box className="subscriptioncardheader">
              <img src={StackPackImage} alt="StackPack" className="stackpack" />
            </Box>
            <Typography
              variant="h5"
              fontWeight="bold"
              gutterBottom
              className="pricetitle"
            >
              {plan.name}
            </Typography>
          </>
        ) : (
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            {plan.name}
          </Typography>
        )}

        <Typography variant="h4" gutterBottom className="pricetext">
          {selectedCurrency === "INR"
            ? `₹${plan.totalInrCost}`
            : `$${plan.totalCost}`}
        </Typography>

        <Typography variant="body1" gutterBottom className="pricedescription">
          {plan.description ||
            "Effortlessly Extract Insights from Unstructured Documents with AI-Powered Precision"}
        </Typography>

        <Box sx={{ mt: 2, textAlign: "left" }}>
          {plan.features.map((feature, index) => (
            <Typography key={index} variant="body2" className="featuretext">
              <CheckBox className="checkbox-icon"/> {feature}
            </Typography>
          ))}
        </Box>

        <ButtonComponent
          onClick={() => handleCheckoutSession(plan)}
          className="subscriptionbtn"
          text="Get Started with HaawkAI"
        />
      </Paper>
    </Grid>
  );
};

export default SubscriptionCard;
